module.exports = __webpack_public_path__ + "static/media/4-9.c241f4a0.mp3";